import { PlanningTypes } from 'pages/admin/demand/planning/context/types/contextPrevision.type';

export type RowType =
	| 'collaboration'
	| 'history'
	| 'opportunity'
	| 'fill'
	| 'totalQuantity'
	| 'previousYear'
	| 'previousCycle';

export interface IOpportunityClient {
	id: number;
	companyName: string;
}

export interface IOpportunityClientData {
	client: IOpportunityClient;
	date: string;
	quantity: number;
}

export interface IOpportunityData {
	listByMonth: Record<string, number> | null;
	listByClient: IOpportunityClientData[] | null;
	year: number;
	cycle: number;
}

export interface IOpportunitiesWithExceptionsData {
	months: Record<string, number>;
	average: number;
	total: number;
	growth: number;
}

export interface IPrevisionDraft {
	quantity: number;
	monthIndex: number;
	year: number;
}

export type ConsensusCollaborationTag =
	| 'optimistic'
	| 'pessimistic'
	| 'moderate'
	| 'uniform'
	| 'noCollaboration';

export interface IPlanningByLevelTableRow {
	id: string;
	rowType: RowType;
	label: string;
	areaId?: number;
	isDraggable?: boolean;
	consensusCollaborationTag?: ConsensusCollaborationTag;
	months: Record<string, number>;
	average?: number;
	total?: number;
	growth?: number;
	isEditable?: boolean;
}

export interface IPlanningByLevelTableProps {
	screenType: PlanningTypes;
	cycleMonths: string[];
	data: IPlanningByLevelTableRow[];
	indicatorsSelect?: React.ReactNode;
}

export interface IColumnConfig {
	field: string;
	headerName: string;
	width?: number;
	pinned?: 'left' | 'right' | boolean;
	cellRenderer?: string;
	valueFormatter?: (params: {
		value: string | number | boolean | null | undefined;
	}) => string;
	cellStyle?: Record<string, string | number>;
	editable?:
		| boolean
		| ((params: { data?: IPlanningByLevelTableRow }) => boolean);
}

export const GRID_STYLES = {
	wrapper: {
		height: '100%',
		width: '100%',
		display: 'flex',
		flexDirection: 'column' as const,
	},
	gridContainer: {
		flex: 1,
		minHeight: 0,
	},
};
